export default __webpack_public_path__ + "static/media/own_rent_map_image.4f301f40.png";